/**
 * Spacing constants used for padding, margins, etc. Use this enumeration to
 * access to the CSS values from TypeScript.
 *
 * To access the spacing values from CSS, use the CSS variables defined in
 * [css-variables.css](https://github.com/farmersdog/beethoven/blob/main/packages/corgi-x/src/styles/css-variables.css)
 */

/** @deprecated Use the {@link SpacingValue} instead. */
export type SpacingSize = Lowercase<keyof typeof Spacing>;

/** Legacy spacing values — avoid in new code, prefer 8px-grid values. */
type LegacySpacingValue = 2 | 6 | 20 | 36;

/** 8px-grid spacing values for new development. */
type GridSpacingValue =
  | 0
  | 4
  | 8
  | 12
  | 16
  | 24
  | 32
  | 40
  | 48
  | 56
  | 64
  | 72
  | 80
  | 88
  | 96
  | 104
  | 112
  | 120
  | 160;

/**
 * All available spacing values. Legacy values are retained for backward
 * compatibility.
 *
 * @see https://corgi-x.tfd.engineering/system/spacings
 */
export type SpacingValue = GridSpacingValue | LegacySpacingValue;

/**
 * @deprecated Use the `<Box />` component to add spacing to HTML elements. For
 *   typings, use the {@link SpacingValue} instead.
 * @see https://corgi-x.tfd.engineering/components/box
 * @see https://corgi-x.tfd.engineering/system/spacings
 */
export enum Spacing {
  None = 0,
  /** XXS spacing in px. */
  XXS = 2,
  /** Extra small spacing in px. */
  XS = 6,
  /** Small spacing in px. */
  SM = 12,
  /** Medium spacing in px. */
  MD = 24,
  /** Large spacing in px. */
  LG = 36,
  /** Extra-large spacing inx px. */
  XL = 48,
  /** XXL spacing inx px. */
  XXL = 72,
  /** 3XL spacing in px. */
  '3XL' = 96,
  /** 4XL spacing in px. */
  '4XL' = 120,
}
